import { Beat } from '../../models';

export default [
  {
    id: -1,
    loops: 5,
    bpm: 100,
    layers: [
      {
        pattern:
          'B B B B BB BB BB BB B B B B BBB BBB BBB BBB B B B B BBBB BBBB BBBB BBBB',
      },
    ],
    sounds: [],
  },
  {
    id: -1,
    loops: 5,
    bpm: 80,
    layers: [
      {
        pattern:
          'B B[d1] Pf B[d1] B B[d1] Pf B[d1] B B[d1]B Pf B[d1]B B B[d1]B Pf B[d1]B B B[d1]B[d1] Pf B[d1]B[d1] B B[d1]B[d1] Pf B[d1]B[d1] B B[d1]B[d1]B Pf B[d1]B[d1]B B B[d1]B[d1]B Pf B[d1]B[d1]B B B[d1]B[d1]B[d1] Pf B[d1]B[d1]B[d1] B B[d1]B[d1]B[d1] Pf B[d1]B[d1]B[d1] B B[d1]B[d1]B[d1]B Pf B[d1]B[d1]B[d1]B B B[d1]B[d1]B[d1]B Pf B[d1]B[d1]B[d1]B B B[d1]B[d1]B[d1]B[d1] Pf B[d1]B[d1]B[d1]B[d1] B B[d1]B[d1]B[d1]B[d1] Pf B[d1]B[d1]B[d1]B[d1]',
      },
    ],
    sounds: [],
  },
] as Beat[];
